import {
    CheckCircleOutline,
    Delete,
    DoDisturbOn,
    Edit,
} from "@mui/icons-material";
import {
    Alert,
    Button,
    CircularProgress,
    FormControl,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
    TextField,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
// import { DataGrid, GridRowsProp, GridColDef } from "@mui/x-data-grid";
import {
    ProgressStyled,
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import { toast } from "react-toastify";

import {
    DeletePanel,
    PanelsSearch,
    reset,
} from "../../Redux/PanlesSlice/PanelsSlice";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { DeleteModal } from "../../Components/Modal/Modals";

const PanelsDataGrid = () => {
    const dispatch = useDispatch();

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    // Filter By Fields Variables
    const [title, setTitle] = useState("");
    const [wattage, setWattage] = useState("");
    const [state, setState] = useState("");
    const [price, setPrice] = useState("");
    const [is_active, setIsactive] = useState("");
    const searchObj = {
        title,
        wattage,
        state,
        price,
        is_active,
    };

    const [tableId, setTableId] = useState(null);
    const { search, panels, isSuccess, isLodaing, isError } = useSelector(
        (state) => state.panels
    );
    const DataTable = panels?.data?.data || [];
    const PanelsPagination = panels?.data || [];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);

        const callSearchAction = async () => {
            await dispatch(
                PanelsSearch({
                    ...searchObj,
                    paginate: rowsPerPage,
                    page: newPage + 1,
                })
            );
            await dispatch(reset());
        };
        callSearchAction();
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
        const callSearchAction = async () => {
            await dispatch(
                PanelsSearch({ ...searchObj, paginate: event.target.value })
            );
            await dispatch(reset());
        };
        callSearchAction();
    };

    const handelFilterAction = async (obj) => {
        await dispatch(PanelsSearch({ ...obj, paginate: rowsPerPage }));
        await dispatch(reset());
    };

    const handelResetData = async () => {
        await setTitle(null);
        await setWattage(null);
        await setState(null);
        await setPrice(null);
        await setIsactive(null);
        await handelFilterAction({});
    };

    function inputKeyUp(e) {
        e.which = e.which || e.keyCode;
        if (e.which === 13) {
            //Key code of Enter
            handelFilterAction(searchObj);
        }
    }

    // Delete Utility Confirm
    const [data, setData] = useState({});
    const [open, setOpen] = useState(false);

    const handleOpen = async (data) => {
        await setData(data);
        await setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setData({});
    };
    const DeleteRow = async () => {
        handleClose();
        await dispatch(
            DeletePanel({
                panel_id: data.id,
            })
        );
        await toast.success("Panel deleted success");
        await setTableId(data.id);
        await dispatch(PanelsSearch({ paginate: rowsPerPage }));
        await dispatch(reset());
    };

    const handelDeletePanels = async (data) => {
        handleOpen(data);
    };

    // useEffect(() => {
    //   if (panels) {
    //     if (isError) {
    //       toast.error("cant delete Panel");
    //     }
    //     if (isSuccess) {
    //       toast.success("New Panel deleted");
    //     }
    //   }

    //   dispatch(reset());
    // }, [panels, isSuccess, isError, dispatch]);

    // useEffect(() => {
    // 	if (search != null) {
    // 		const callSearchAction = async () => {
    // 			setRowsPerPage(20);
    // 			await dispatch(PanelsSearch({ search: search }));
    // 			await dispatch(reset());
    // 		};
    // 		callSearchAction();
    // 	}
    // }, [search, dispatch]);

    return (
        <>
            {/* <div style={{ height: 600, width: "100%", background: "var(--white)" }}>
        {DataTable && (
          <DataGrid rows={DataTable} columns={columns} pageSize={5} />
        )}
      </div> */}
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && !isSuccess && (
                <TableContainerStyled component={Paper}>
                    <Table aria-label="simple table">
                        <TableHeadStyled>
                            <TableRow>
                                <TableCell style={{ padding: "5px" }}>
                                    Filter By :
                                </TableCell>
                                <TableCell
                                    style={{ padding: "5px" }}
                                    width={500}
                                >
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="title"
                                            name="title"
                                            label="Title"
                                            value={title}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setTitle(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="wattage"
                                            name="wattage"
                                            label="Wattage"
                                            value={wattage}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setWattage(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="state"
                                            name="state"
                                            label="State"
                                            value={state}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setState(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>
                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="price"
                                            name="price"
                                            label="Price"
                                            value={price}
                                            onKeyUp={(e) => inputKeyUp(e)}
                                            onChange={(e) => {
                                                setPrice(e.target.value);
                                            }}
                                        />
                                    </Grid>
                                </TableCell>

                                <TableCell style={{ padding: "5px" }}>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">
                                                Active
                                            </InputLabel>
                                            <Select
                                                id="is_active"
                                                name="is_active"
                                                label="Active"
                                                value={is_active}
                                                onChange={(e) =>
                                                    setIsactive(e.target.value)
                                                }
                                            >
                                                <MenuItem value="2">
                                                    Inactive
                                                </MenuItem>
                                                <MenuItem value="1">
                                                    Active
                                                </MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </TableCell>

                                <TableCell
                                    style={{ padding: "5px" }}
                                    align="center"
                                >
                                    <Grid container coulmns={12}>
                                        <Button
                                            style={{ marginBottom: "5px" }}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={(e) =>
                                                handelFilterAction(searchObj)
                                            }
                                        >
                                            <FilterAltIcon></FilterAltIcon>
                                        </Button>
                                        <Button
                                            fullWidth
                                            variant="contained"
                                            color="error"
                                            onClick={(e) => handelResetData()}
                                        >
                                            <RestartAltIcon></RestartAltIcon>
                                        </Button>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableHeadStyled>
                            <TableRow>
                                <TableCell>#</TableCell>
                                <TableCell>TILIE</TableCell>
                                <TableCell>Wattage </TableCell>
                                <TableCell>State</TableCell>
                                <TableCell>Price</TableCell>
                                <TableCell align="center"> Default</TableCell>

                                <TableCell align="center">ACTIONS </TableCell>
                            </TableRow>
                        </TableHeadStyled>

                        <TableBody>
                            {DataTable.map((panel, index) => (
                                <TableRowStyled key={index}>
                                    <TableCellStyle>
                                        {rowsPerPage * page + index + 1}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {panel.title}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {panel.wattage}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {panel.state?.name || "___"}
                                    </TableCellStyle>
                                    <TableCellStyle>
                                        {panel.price ? `$` + panel.price : 0}
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        {panel.is_default !== 0 ? (
                                            <CheckCircleOutline color="primary" />
                                        ) : (
                                            <DoDisturbOn />
                                        )}
                                    </TableCellStyle>
                                    <TableCellStyle align="center">
                                        <IconButton
                                        >
                                            <Link to={"edit=" + panel.id}>
                                                <Edit color="primary" />
                                            </Link>
                                        </IconButton>
                                        <IconButton
                                            onClick={() =>
                                                handelDeletePanels(panel)
                                            }
                                        >
                                            {tableId === panel.id && (
                                                <ProgressStyled>
                                                    <CircularProgress
                                                        size={30}
                                                        color="error"
                                                    />
                                                </ProgressStyled>
                                            )}

                                            <ProgressStyled>
                                                <Delete color="error" />
                                            </ProgressStyled>
                                        </IconButton>
                                    </TableCellStyle>
                                </TableRowStyled>
                            ))}
                        </TableBody>

                        <TableHeadStyled>
                            <TableRow>
                                {PanelsPagination.total >= 20 && (
                                    <TablePagination
                                        rowsPerPageOptions={[
                                            20,
                                            50,
                                            100,
                                            { label: "All", value: -1 },
                                        ]}
                                        colSpan={12}
                                        count={PanelsPagination.total}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        onRowsPerPageChange={
                                            handleChangeRowsPerPage
                                        }
                                    />
                                )}
                            </TableRow>
                        </TableHeadStyled>
                    </Table>

                    {PanelsPagination.total < 1 && (
                        <Alert icon={false} severity="error">
                            <Typography
                                variant="h6"
                                className="MuiTypography-alignCenter"
                            >
                                There are no items, please try again
                            </Typography>
                        </Alert>
                    )}
                </TableContainerStyled>
            )}

            {/* delete modal  */}
            <DeleteModal
                open={open}
                close={handleClose}
                title={data?.title}
                onClick={DeleteRow}
                loading={isLodaing}
            />
        </>
    );
};

export default PanelsDataGrid;
